import { ChangePasswordInput, User } from 'src/shared/types/User';
import { IdaasAxiosInstance } from '../axios/axios';

export const getUserInfo = async (): Promise<User> => {
  const response = await IdaasAxiosInstance.get('user');
  return response.data;
};

export const changePassword = async (changePasswordInput: ChangePasswordInput) => {
  const response = await IdaasAxiosInstance.put('account/change_password', changePasswordInput);
  return response.data;
};

export const getNewRecoveryKey = async (): Promise<{ emergencyRecoveryKey: string }> => {
  const response = await IdaasAxiosInstance.get('user/erk');
  return response.data;
};
